var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticSettlement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1356DA;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.66,
    y: 13.33,
    width: 25.65,
    height: 32.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "42.33 45.58 42.33 50.67 16.69 50.67 16.69 18.42 21.66 18.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.68,
    y1: 19.63,
    x2: 41.29,
    y2: 19.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.68,
    y1: 24.55,
    x2: 41.29,
    y2: 24.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.68,
    y1: 29.46,
    x2: 41.29,
    y2: 29.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.68,
    y1: 34.37,
    x2: 41.29,
    y2: 34.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.68,
    y1: 39.28,
    x2: 41.29,
    y2: 39.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "47.31 26.54 56.52 26.54 56.52 13.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.87,
    y: 4.49,
    width: 9.01,
    height: 9.01
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "47.31 32.37 56.52 32.37 56.52 45.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.87,
    y: 45.42,
    width: 9.01,
    height: 9.01
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.69 37.46 7.48 37.46 7.48 50.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.13,
    y: 50.5,
    width: 9.01,
    height: 9.01,
    transform: "translate(15.26 110.01) rotate(180)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.69 31.63 7.48 31.63 7.48 18.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.13,
    y: 9.58,
    width: 9.01,
    height: 9.01,
    transform: "translate(15.26 28.16) rotate(180)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticSettlement);
export default __webpack_public_path__ + "static/media/automatic-settlement.1dec81070027f8f8c7925c3466acc321.svg";
export { ForwardRef as ReactComponent };